var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { consume } from '@lit/context';
import { LitElement, html } from 'lit';
import { authenticationContext } from '../../../Authentication/context';
import { registerCustomElement } from '../../../utils/registerCustomElement';
import { styles } from './styles';
import '../../../Button';
import '../../../Icon';
let ModalUpgradeApple = class ModalUpgradeApple extends LitElement {
    constructor() {
        super(...arguments);
        // Close/dismiss
        this._close = () => {
            this.dispatchEvent(new CustomEvent('close'));
        };
    }
    render() {
        return html `<div class="apple">
      <h2 class="title">Please upgrade through the App Store</h2>
      <div class="split">
        <div class="qr">
          <grain-icon name="appleUpgradeQR" width="100%" height="auto" />
        </div>
        <div class="text">
          <p>
            It looks like you purchased your membership through the App Store on
            iOS. That means you will need to upgrade to Pro through the App
            Store as well.
          </p>
          <p>Use the QR code on your iOS device to upgrade.</p>
        </div>
      </div>
      <div class="buttons">
        <grain-button @click=${() => this._close()} size="lg" ?fullwidth=${true}
          >Cancel</grain-button
        >
      </div>
    </div>`;
    }
};
ModalUpgradeApple.styles = styles;
__decorate([
    consume({ context: authenticationContext, subscribe: true })
], ModalUpgradeApple.prototype, "authentication", void 0);
ModalUpgradeApple = __decorate([
    registerCustomElement('grain-modal-upgrade-apple')
], ModalUpgradeApple);
export { ModalUpgradeApple };
